import { Pricing } from '../components/Pricing';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { PageSeo } from '../components/seo/PageSeo';
import { PRICING_META } from '../lib/seo';

export function PricingPage() {
  return (
    <MarketingLandingShell pageClassName="page-pricing">
      <PageSeo meta={PRICING_META} />
      <Pricing />
      <section className="section band-dark" aria-labelledby="pricing-production-cost-title">
        <div className="container py-20">
          <h2 id="pricing-production-cost-title" className="mkt-section-title">Cost Per Finished Minute: Induce vs Traditional Production</h2>
          <p className="body-lg max-w-3xl">Traditional production runs $5,000–$40,000 per finished minute and takes weeks. Induce runs $300–$800 per finished minute and ships in hours to days.</p>
        </div>
      </section>
    </MarketingLandingShell>
  );
}
